import { Backdrop, Grid, Typography } from "@mui/material";
import { createContext, useEffect, useMemo, useState } from 'react'
import { FnAxios } from "utilities/utilities";
import "../Dashboard/../ProjectSupport/ProjectSupport.css";
import { FormProvider, useForm } from "react-hook-form";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { BtnBack, BtnSearch } from "components/Button/ButtonAll";
import CardProjectSupport from "./CardProjectSupport";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import moment from "moment";
import ProjectPieChartUnit from "./Amcharts/ProjectPieChartUnit";
import ProjectPieChartUnitType from "./Amcharts/ProjectPieChartUnitType";
import ProjectPieChartOprerrationt from "./Amcharts/ProjectPieChartOprerrationt";
import ProjectMap from "./Amcharts/ProjectMap";
import ProjectPieChartSection from "./Amcharts/ProjectPieChartSection";
import ProjectChart from "./Amcharts/ProjectChart";
import ChartSectionJournal from "./Amcharts/ChartSectionJournal";
import ChartSectionMedia from "./Amcharts/ChartSectionMedia";
import { FilterAlt, Replay } from "@mui/icons-material";
import ChartSectionPresentation from "./Amcharts/ChartSectionPresentation";
import MapChart from "../Expense/Chart/MapChart";
import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";

export const ProviderProjectDashboard = createContext(null);
const ProjectSupportDashboard = () => {

    const AxiosFn = FnAxios();
    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    const [ArrProject, setArrProject] = useState<any>([]);
    const [ArrProjectType, setArrProjectType] = useState([]);
    const [ArrUnitType, setArrUnitType] = useState([]);
    const [ArrSection, setArrSection] = useState([]);
    const [ArrProvince, setArrProvince] = useState([]);
    const [ArrSubdistrict, setArrSubdistrict] = useState([]);
    const [ArrDistrict, setArrDistrict] = useState([]);
    const [nProjectTotal, setProjectTotal] = useState(0);
    const [nApproveBudgetTotal, setApproveBudgetTotal] = useState(0);


    const [lstProjectChart, setlstProjectChart] = useState<any>([]);
    const [lstMapChart, setlstMapChart] = useState([]);
    const [lstMapProject, setlstMapProject] = useState([]);
    const [lstProjectUnitChart, setlstProjectUnitChart] = useState<any>([]);
    const [lstProjectUnitTypeChart, setlstProjectUnitTypeChart] = useState<any>([]);
    const [lstUnitTypeChartSub, setlstUnitTypeChartSub] = useState<any>([]);
    const [nEventUnitType, setnEventUnitType] = useState(0);
    const [lstSectionPieChart, setlstSectionPieChart] = useState<any>([]);
    const [lstOperrationtPieChart, setlstOperrationtPieChart] = useState<any>([]);
    const [lstPresentation, setlstPresentation] = useState<any>([]);
    const [lstJournalChart, setlstJournalChart] = useState<any>([]);
    const [lstMediaChart, setlstMediaChart] = useState<any>([]);
    const [lstYear, setlstYear] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false)
    const currentDate = new Date(); // Get the current date
    const _dYearStart = new Date(currentDate.getFullYear() - 2, 0, 1);
    const _dYearEnd = new Date(currentDate.getFullYear(), 0, 1);

    const getFormInitial = () => {

        AxiosFn.Get(`ProjectDashboard/GetFormInitial`, {}, (result) => {
            setArrUnitType(result.lstProjectUnitType);
            setArrProjectType(result.lstProjectOperationType);
            setArrSection(result.lstSection);
            setArrProvince(result.lstProvince);
            // setArrSubdistrict(result.lstSubdistrict);
            // setArrDistrict(result.lstDistrict);
        })
    }

    const onGetProject = () => {
        let param = {
            lstOperationTypeID: form.getValues("nOperationTypeID"),
        }
        AxiosFn.Post(`ProjectDashboard/GetDataProject`, param, (result) => {
            setArrProject(result.lstProject || []);
        })
    }

    const GetDataMap = () => {
        let param = {
            nYearStart: moment(form.getValues("dYearStart")).valueOf(),
            nYearEnd: moment(form.getValues("dYearEnd")).valueOf(),
            lstUnitTypeID: form.getValues("nUnitTypeID"),
            lstOperationTypeID: form.getValues("nOperationTypeID"),
            lstSectionID: form.getValues("nSeactionID"),
            lstProjectID: form.getValues("nProjectID"),
            lstProvinceID: form.getValues("nProvinceID") ?? [],
            lstDistrictID: form.getValues("nDistrictID") ?? [],
            lstSubdistrictID: form.getValues("nSubdistrictID") ?? [],
            sAreaName: form.getValues("sAreaName")
        }

        AxiosFn.Post(`ProjectDashboard/GetMapChart`, param, (result) => {

            let data = result.objResult;
            if (data) {
                setlstMapChart(data.lstMapChart);
                setlstMapProject(data.lstMapProject);
            }
        })
    }

    const GetDataProject = () => {
        setIsLoading(false)
        let param = {
            nYearStart: moment(form.getValues("dYearStart")).valueOf(),
            nYearEnd: moment(form.getValues("dYearEnd")).valueOf(),
            lstUnitTypeID: form.getValues("nUnitTypeID"),
            lstOperationTypeID: form.getValues("nOperationTypeID"),
            lstSectionID: form.getValues("nSeactionID"),
            lstProjectID: form.getValues("nProjectID"),
        }
        AxiosFn.Post(`ProjectDashboard/GetDataDashboardProject`, param, (result) => {
            setIsLoading(true)
            setProjectTotal(result.nProjectTotal);
            setApproveBudgetTotal(result.nApproveBudgetTotal);
            setlstProjectChart(result.lstProjectChart || []);
            setlstProjectUnitChart(result.lstProjectUnitChart || []);
            setlstProjectUnitTypeChart(result.lstUnitTypeChart || []);
            setlstUnitTypeChartSub(result.lsUnitTypeChartsub || []);
            setlstSectionPieChart(result.lstSectionPieChart || []);
            setlstOperrationtPieChart(result.lstOperrationtPieChart || []);
            setlstPresentation(result.lstPresentationChart || []);
            setlstJournalChart(result.lstJournalChart || []);
            setlstMediaChart(result.lstMediaChart || []);
        });

        GetDataMap();

        form.setValue("nProvinceID", null);
        form.setValue("nDistrictID", null);
        form.setValue("nSubdistrictID", null);
    }

    const GetDataYear = () => {
        let param = {
            nYearStart: moment(form.getValues("dYearStart")).valueOf(),
            nYearEnd: moment(form.getValues("dYearEnd")).valueOf(),
        }
        AxiosFn.Post(`ProjectDashboard/GetDataYear`, param, (result) => {
            setlstYear(result.lstYear || []);
        })
    }

    const GetDistrict = (e) => {

        let param = {
            lstProvinceID: form.getValues("nProvinceID"),
        }
        AxiosFn.Post(`ProjectDashboard/GetDistrict`, param, (result) => {
            setArrDistrict(result.lstDistrict);
            let nDistrictID = form.getValues("nDistrictID")

            form.setValue("nDistrictID", null);
            //   form.setValue("nSubdistrictID", null);

            let arrClone = result.lstDistrict.filter((f) => e.includes(f.nParentID));
            let arrClonenew = arrClone.filter((f) => nDistrictID.includes(f.value));
            let lstDataType = [];
            arrClonenew.forEach((item) => {
                lstDataType.push(item.value)
            })
            form.setValue("nDistrictID", lstDataType);
            GetSubdistrict(nDistrictID)
        })
    }

    const GetSubdistrict = (e) => {
        let param = {
            lstDistrictID: form.getValues("nDistrictID"),
        }
        AxiosFn.Post(`ProjectDashboard/GetSubdistrict`, param, (result) => {
            setArrSubdistrict(result.lstSubdistrict);
            let nSubdistrictID = form.getValues("nSubdistrictID")
            form.setValue("nSubdistrictID", null);
            let arrClone = result.lstSubdistrict.filter((f) => e.includes(f.nParentID));
            let arrClonenew = arrClone.filter((f) => nSubdistrictID.includes(f.value));
            let lstData = [];
            arrClonenew.forEach((item) => {
                lstData.push(item.value)
            })
            form.setValue("nSubdistrictID", lstData);
        })
    }

    const GetDataProjectUnit = () => {
        let param = {
            lstYearStartUnit: form.getValues("nYearStartUnit"),
        }
        AxiosFn.Post(`ProjectDashboard/GetDataProjectUnit`, param, (result) => {
            setlstProjectUnitChart(result.lstProjectUnitChart || []);
        })
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getFormInitial();
        form.setValue("dYearStart", _dYearStart);
        form.setValue("dYearEnd", _dYearEnd);
        GetDataProject();
        GetDataYear();
    }, [])

    const objProjectDashboard = useMemo(() => (
        {
            nProjectTotal,
            setProjectTotal,
            nApproveBudgetTotal,
            setApproveBudgetTotal,
            lstProjectChart,
            setlstProjectChart,
            lstProjectUnitChart,
            setlstProjectUnitChart,
            lstProjectUnitTypeChart,
            setlstProjectUnitTypeChart,
            nEventUnitType,
            setnEventUnitType,
            lstUnitTypeChartSub,
            setlstUnitTypeChartSub,
            lstSectionPieChart,
            setlstSectionPieChart,
            lstOperrationtPieChart,
            setlstOperrationtPieChart,
            lstPresentation,
            setlstPresentation,
            lstJournalChart,
            setlstJournalChart,
            lstMediaChart,
            setlstMediaChart
        }
    ), [
        nProjectTotal,
        setProjectTotal,
        nApproveBudgetTotal,
        setApproveBudgetTotal,
        lstProjectChart,
        setlstProjectChart,
        lstProjectUnitChart,
        setlstProjectUnitChart,
        lstProjectUnitTypeChart,
        setlstProjectUnitTypeChart,
        nEventUnitType,
        setnEventUnitType,
        lstUnitTypeChartSub,
        setlstUnitTypeChartSub,
        lstSectionPieChart,
        setlstSectionPieChart,
        lstOperrationtPieChart,
        setlstOperrationtPieChart,
        lstPresentation,
        setlstPresentation,
        lstJournalChart,
        setlstJournalChart,
        lstMediaChart,
        setlstMediaChart
    ]);

    return (
        <>
            <FormProvider {...form}>
                <Grid item container xs={12} md={12} className='div-breadcrumbs-ProjectSupport' sx={{ mt: 5, justifyContent: "center" }} >
                    <Typography variant="h4" color={"#FCEE9E"}>สถิติโครงการที่ได้รับการสนับสนุนประจำปี</Typography>
                </Grid>

                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={12} >
                        <Grid item className='div-search-ProjectSupport'>
                            <Grid container spacing={2} >
                                <Grid item xs={12} md={2}>
                                    <DatePickerItem
                                        name={`dYearStart`}
                                        id={`dYearStart`}
                                        label={`ตั้งแต่ปี`}
                                        IsYearPicker
                                        required={false}
                                        disabled={false}
                                        fullWidth
                                        maxDate={form.watch("dYearEnd")}
                                        onChange={(e) => {
                                            GetDataYear()
                                        }}

                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <DatePickerItem
                                        name={`dYearEnd`}
                                        id={`dYearEnd`}
                                        label={`ถึงปี`}
                                        IsYearPicker
                                        required={false}
                                        disabled={false}
                                        minDate={form.watch("dYearStart")}
                                        fullWidth
                                        onChange={(e) => {
                                            GetDataYear()
                                        }}
                                    />
                                </Grid>
                                <Grid item container xs={12} md={4}>
                                    <MultipleSelectItem
                                        id={'nUnitTypeID'}
                                        name={'nUnitTypeID'}
                                        label={"ประเภทหน่วยงานที่ขอรับทุน"}
                                        placeholder={'ประเภทหน่วยงานที่ขอรับทุน'}
                                        options={ArrUnitType || []}
                                        required={false}
                                        disabled={false}
                                    />

                                </Grid>
                                <Grid item container xs={12} md={4}>
                                    <MultipleSelectItem
                                        id={'nOperationTypeID'}
                                        name={'nOperationTypeID'}
                                        label={"ลักษณะการดำเนินงาน"}
                                        placeholder={'ลักษณะการดำเนินงาน'}
                                        options={ArrProjectType || []}
                                        required={false}
                                        disabled={false}
                                        onChange={(e) => {
                                            onGetProject()

                                        }}
                                    />
                                </Grid>

                                <Grid item container xs={12} md={6}>
                                    <MultipleSelectItem
                                        id={'nSeactionID'}
                                        name={'nSeactionID'}
                                        label={"มาตรา"}
                                        placeholder={'มาตรา'}
                                        options={ArrSection || []}
                                        required={false}
                                        disabled={false}
                                    />
                                </Grid>

                                <Grid item container xs={12} md={6}>
                                    <MultipleSelectItem
                                        id={'nProjectID'}
                                        name={'nProjectID'}
                                        label={"โครงการ"}
                                        placeholder={'โครงการ'}
                                        options={ArrProject || []}
                                        required={false}
                                        disabled={false}
                                    />
                                </Grid>

                                <Grid item container gap={2} justifyContent="center">
                                    <BtnSearch id="search"
                                        onClick={form.handleSubmit(() => GetDataProject(), (err) => console.log("err", err))}
                                    />
                                    {/* <BtnClear id="ClearID"
                                    // onClick={() => onClearData()} 
                                    /> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <ProviderProjectDashboard.Provider value={objProjectDashboard} >
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Grid container gap={2}>
                                <Grid item md={6} xs={12} >
                                    <Grid container spacing={2}>
                                        <Grid item md={6} xs={12} >
                                            <CardProjectSupport sMode="Total" />
                                        </Grid>
                                        <Grid item md={6} xs={12} >
                                            <CardProjectSupport sMode="Price" />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <ProjectChart />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={5.8} xs={12} >
                                    <Grid container justifyContent={"flex-end"}>
                                        <Grid container justifyContent={"flex-end"} alignItems={"center"}>
                                            <Grid item md={1}>
                                                <FilterAlt style={{ fontSize: '2.5em' }} /></Grid>
                                            <Grid item xs={12} md={4}>
                                                <MultipleSelectItem
                                                    id={'nYearStartUnit'}
                                                    name={'nYearStartUnit'}
                                                    label={"ปี"}
                                                    placeholder={'ปี'}
                                                    options={lstYear || []}
                                                    required={false}
                                                    disabled={false}
                                                    onChange={() => { GetDataProjectUnit() }}
                                                    limitTag={1}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} >
                                            <ProjectPieChartUnit />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={12} xs={12} sx={{ mt: 5 }}>
                                <Grid container gap={2}>
                                    <Grid item xs={12} md={6} >
                                        {nEventUnitType !== 0 &&
                                            <div
                                                onClick={() => setnEventUnitType(0)}
                                                style={{
                                                    color: "blue",
                                                    marginLeft: 10,
                                                    cursor: "pointer",
                                                    fontWeight: 500,
                                                    marginTop: 10
                                                }} >
                                                <Grid container wrap="nowrap">
                                                    <Grid item ><Replay style={{ fontSize: '1.5em' }} />
                                                    </Grid>  <Grid item xs>
                                                        <Typography >กลับ</Typography>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        }
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <ProjectPieChartUnitType />
                                    </Grid>
                                    <Grid item md={5.4} xs={12}  >
                                        <ProjectPieChartSection />
                                    </Grid>

                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} sx={{ mt: 5 }}>
                                <ProjectPieChartOprerrationt />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} md={12} >
                            <Grid item className='div-search-map' sx={{ mt: 2 }}>
                                <Grid container spacing={2} >
                                    <Grid item container xs={12} md={4}>
                                        <MultipleSelectItem
                                            id={'nProvinceID'}
                                            name={'nProvinceID'}
                                            label={"จังหวัด"}
                                            placeholder={'จังหวัด'}
                                            options={ArrProvince || []}
                                            required={false}
                                            disabled={false}
                                            onChange={(e) => {
                                                GetDistrict(e != null ? e : 0);


                                            }}
                                        />
                                    </Grid>
                                    <Grid item container xs={12} md={4}>
                                        <MultipleSelectItem
                                            id={'nDistrictID'}
                                            name={'nDistrictID'}
                                            label={"อำเภอ"}
                                            placeholder={'อำเภอ'}
                                            options={ArrDistrict || []}
                                            required={false}
                                            disabled={false}
                                            onChange={(e) => {
                                                GetSubdistrict(e != null ? e : 0)

                                            }}
                                        />
                                    </Grid>
                                    <Grid item container xs={12} md={4}>
                                        <MultipleSelectItem
                                            id={'nSubdistrictID'}
                                            name={'nSubdistrictID'}
                                            label={"ตำบล"}
                                            placeholder={'ตำบล'}
                                            options={ArrSubdistrict || []}
                                            required={false}
                                            disabled={false}

                                        />
                                    </Grid>
                                    <Grid item container gap={2} justifyContent="center">
                                        <BtnSearch id="search"
                                            onClick={form.handleSubmit(() => GetDataMap(), (err) => console.log("err", err))}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} sx={{ mt: 2 }}>
                            {/* <ProjectMap /> */}
                            <MapChart map={lstMapChart} project={lstMapProject} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography>สัดส่วนวงเงินแยกตามจังหวัด</Typography>
                                </Grid>
                                <Grid item >
                                    <div style={{ width: '70px', borderRadius: '4px', textAlign: 'center', padding: '8px', backgroundColor: '#d9d9d9' }}>  {"0%"}</div>
                                </Grid>
                                <Grid item >
                                    <div style={{ width: '70px', borderRadius: '4px', textAlign: 'center', padding: '8px', backgroundColor: '#FFA6A1' }}>{"< 30%"}</div>
                                </Grid>
                                <Grid item >
                                    <div style={{ width: '70px', borderRadius: '4px', textAlign: 'center', padding: '8px', backgroundColor: '#FF6961', color: '#ffffff' }}>  <span>&#8805;</span>{" 30%"}</div>
                                </Grid>
                                <Grid item >
                                    <div style={{ width: '70px', borderRadius: '4px', textAlign: 'center', padding: '8px', backgroundColor: '#FF2C21', color: '#ffffff' }}>   <span>&#8805;</span>{" 60%"}</div>
                                </Grid>
                                <Grid item >
                                    <div style={{ width: '70px', borderRadius: '4px', textAlign: 'center', padding: '8px', backgroundColor: '#E10B00', color: '#ffffff' }}>  <span>&#8805;</span>{" 80%"}</div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} sx={{ mt: 5 }}>
                            <Grid item className='div-breadcrumbs-section' >
                                <Grid container sx={{ justifyContent: "left" }}>
                                    <Typography variant="h5" align="left" color={"#fafafa"}>รายงานการนำเสนอ/ตีพิมพ์วารสารทางวิชาการ มาตรา 40(3)</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <ChartSectionPresentation />
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <ChartSectionJournal />
                        </Grid>
                        <Grid item xs={12} md={12} sx={{ mt: 5 }}>
                            <Grid item className='div-breadcrumbs-section2'>
                                <Grid container sx={{ justifyContent: "left" }}>
                                    <Typography variant="h5" align="left" color={"#fafafa"}>ผลงานโครงการตามมาตรา 40 (4)</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container sx={{ justifyContent: "center" }}>
                            <Grid item xs={12} md={10} sx={{ mt: 1 }}>
                                <ChartSectionMedia />
                            </Grid>
                        </Grid>
                    </ProviderProjectDashboard.Provider>
                </Grid>
                <Backdrop
                    sx={{
                        zIndex: 10000,
                        backgroundColor: "rgba(0, 0, 0, 0.21)",
                    }}
                    open={!isLoading}
                    key={"Backdrop"}
                    id="Backdrop"
                >
                    <div id="page">
                        <div id="container">
                            <div id="ring"></div>
                            <div id="ring"></div>
                            <div id="ring"></div>
                            <div id="ring"></div>
                            <div id="h3">กำลังโหลด</div>
                        </div>
                    </div>
                </Backdrop>

            </FormProvider>
        </>
    );
}
export default ProjectSupportDashboard